import { render, staticRenderFns } from "./DotPulse.vue?vue&type=template&id=41c437de&scoped=true&"
var script = {}
import style0 from "./DotPulse.vue?vue&type=style&index=0&id=41c437de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c437de",
  null
  
)

export default component.exports